import React, {useEffect, useState} from "react";

import {Alert, Button, Modal, Typography} from "antd";
import {EventService} from "../services/eventService";
const { Paragraph, Text } = Typography;

type Props = {
    taskId: string;
    userId: string;
}

export default function Timer(props: Props) {
    const [alert, setAlert] = useState(false);
    const [modal, setModal] = useState(false);

    const extendTime = () => {
        setAlert(false);
        setModal(false);
        const eventService = new EventService();
        const date = new Date();
        eventService.saveEvent(props.userId, props.taskId, {
            id: date.getTime(),
            type: "EXTEND_TIME",
            time: date.toString(),
            value: {
                timesUp: true
            }
        });

        setTimeout(() => {
            const eventService = new EventService();
            const date = new Date();
            eventService.saveEvent(props.userId, props.taskId, {
                id: date.getTime(),
                type: "TASK_END",
                time: date.toString(),
                value: {
                    timesUp: true
                }
            }).then(() => {
                setModal(true);
            }).catch(() => {
                setModal(true);
            });
        }, 2 * 1000 * 60);
    }

    useEffect(() => {
        let alertTime = 4 * 1000 * 60;
        let modalTime = 5 * 1000 * 60;
        if (props.taskId === "1") {
            alertTime = 6 * 1000 * 60;
            modalTime = 7 * 1000 * 60;
        }

        setTimeout(() => {
            setAlert(true);
        }, alertTime);

        setTimeout(() => {
            const eventService = new EventService();
            const date = new Date();
            eventService.saveEvent(props.userId, props.taskId, {
                id: date.getTime(),
                type: "TASK_END",
                time: date.toString(),
                value: {
                    timesUp: true
                }
            }).then(() => {
                setModal(true);
            }).catch(() => {
                setModal(true);
            })
        }, modalTime);
    }, []);

    return (<>
        {alert && (
            <Alert message="One Minute Remaining" closable type="success" />
        )}
        <Modal
            title={`Thank you for completing Task ${props.taskId}!`}
            open={modal}
            closable={false}
            footer={null}
        >
            {props.taskId === "2" ?
                <>
                    <Paragraph>
                        Time is now up!
                    </Paragraph>
                    <Paragraph>
                        If you would like to continue playing with StitchUp, you can extend this task for 2 minutes.
                    </Paragraph>
                    <div className="return-button">
                        <Button onClick={() => extendTime()}>Return to StitchUp</Button>
                    </div>
                    <Paragraph>
                        Otherwise, please return to the survey.
                    </Paragraph>
                    <div className="return-button">
                        <Button type="primary" href="https://ubc.ca1.qualtrics.com/jfe/form/SV_5aJbVNvCqZLIINU">Return to Survey</Button>
                    </div>
                </>
                :
                <>
                    <Paragraph>
                        Time is now up! Please return to the survey.
                    </Paragraph>
                    <div className="return-button">
                        <Button type="primary" href="https://ubc.ca1.qualtrics.com/jfe/form/SV_5aJbVNvCqZLIINU">Return to Survey</Button>
                    </div>
                </>
            }
            <Paragraph>
                <Text italic>If you are not redirected within 5 seconds, please go directly to <Text copyable>https://shorturl.at/BFUY3</Text></Text>
            </Paragraph>
        </Modal>
    </>);
}